import { css } from '@inter-ikea-kompis/web-component';
export default class LanguageSelectorLinkGroupStyle {
    /**
     * Returns styles.
     *
     * @param options Options.
     * @param options.theme Theme.
     * @param options.selected ...
     * @returns Styles.
     */
    static getStyle(options) {
        const { spacing, color, border } = options.theme;
        return css `
			:host {
				position: relative;
			}

			.container {
				display: flex;
			}

			.divider {
				flex-shrink: 0;
				width: ${border.thickness.thin / 16}rem;
				background-color: ${color.border.default};
				margin-left: ${spacing.space50 / 16}rem;
				margin-right: ${spacing.space50 / 16}rem;
			}

			.container skapa-icon {
				margin-inline-end: ${spacing.space100 / 16}rem;
			}

			.divider:last-child {
				display: none;
			}

			kompis-text {
				display: flex;
				align-items: center;
			}

			.link {
				display: inline-flex;
				flex-direction: column;
				align-items: center;
				padding: 0;
				outline: none;

				/* Disabled text selection */
				-webkit-touch-callout: none;
				-webkit-user-select: none;
				-khtml-user-select: none;
				-moz-user-select: none;
				-ms-user-select: none;
				user-select: none;
			}

			.link::before {
				content: attr(data-text);
				height: 0;
				visibility: hidden;
				overflow: hidden;
				user-select: none;
				pointer-events: none;
				font-weight: bold;
			}

			.link[aria-checked='true'] {
				font-weight: bold;
			}

			${this.getActiveStyle(options)}
		`;
    }
    /**
     * Returns hover effect.
     *
     * @param options Options object.
     * @param options.theme Theme.
     * @param options.selected ...
     * @returns Css code.
     */
    static getActiveStyle(options) {
        const { color } = options.theme;
        const inner = css `
			.link:hover {
				color: ${options.selected ? color.neutral.grey100 : color.neutral.grey200};
			}
			.linkSelected:hover {
				color: ${options.selected ? color.neutral.grey100 : color.neutral.grey200};
			}
			.link:active {
				color: ${options.selected ? color.neutral.grey100 : color.neutral.grey300};
			}
			.linkSelected:active {
				color: ${options.selected ? color.neutral.grey100 : color.neutral.grey300};
			}
		`;
        return css `
			/* Prevent hover effect on touch. */
			@media (-moz-touch-enabled: 0), (pointer: fine) {
				${inner}
			}
			/* Needed for IE11 to get an hover effect. */
			@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
				${inner}
			}
		`;
    }
}
//# sourceMappingURL=LanguageSelectorLinkGroupStyle.js.map